var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"fixed-center",attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v(" Aradığınız servis bulunamadı veya aktif değil. Servis sağlayıcınızla görüşün. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }